require 'summernote'
require('../locales/summernote-pt_BR.coffee')

module.exports = (target, options) ->
  jQuery(target).summernote(
    lang: 'pt-BR'
    height: 180
    fontSizes: ['8', '9', '10', '11', '12', '13', '14', '16', '18', '24', '36', '48', '72']
    fontNames: [
          'Arial',
          'Arial Black',
          'Comic Sans MS',
          'Courier New',
          'Helvetica',
          'Helvetica Neue',
          'Impact',
          'Lucida Grande',
          'Tahoma',
          'Times New Roman',
          'Montserrat'
          'Verdana',
      ],
    addDefaultFonts: true
    toolbar: [
      ['fontname', ['fontname']],
      ['fontsize', ['fontsize']],
      ['color', ['color']],
      ['style', ['bold', 'italic', 'underline', 'strikethrough']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['picture', ['picture']],
      ['link', ['link']]
    ],
    cleaner:{
      action: 'paste',
      notStyle: 'display:none',
      keepHtml: true,
      keepClasses: false,
      badTags: ['style', 'script', 'applet', 'embed', 'noframes', 'noscript', 'html'],
      badAttributes: ['style', 'start'],
      limitDisplay: 'both',
      limitStop: false
    },
    callbacks:
      onInit: ->
        jQuery(target).summernote('focus')
        scroll = if !options then true else options.scroll
        jQuery('body, html').scrollTop(0) if scroll
  )



// WEBPACK FOOTER //
// ./src/libraries/summernote.coffee